import { Modal } from "@mantine/core";

import type { PlanDetailsTab } from "./PlanDetails";
import type { VhdpPlanData } from "./vhdpPlanData";

import { PlanDetails } from "./PlanDetails";
import styles from "./PlanDetailsModal.module.css";

export interface PlanDetailsModalProps {
    opened: boolean;
    onClose: () => void;
    data: VhdpPlanData;
    defaultTab?: PlanDetailsTab;
}

/**
 * The real "View plan details" trigger target: `PlanDetails` in a Mantine Modal. Uses the plain
 * `Modal` (not the compound `Modal.Root`) so portaling, centering and z-index are handled for us;
 * the modal chrome (header/close/padding) is suppressed because `PlanDetails` owns its own header,
 * close button and scrolling. Width + height are pinned in the CSS module (see `.content`).
 */
export const PlanDetailsModal = ({ opened, onClose, data, defaultTab }: PlanDetailsModalProps) => (
    <Modal
        opened={opened}
        onClose={onClose}
        size="lg"
        centered
        withCloseButton={false}
        padding={0}
        radius="md"
        classNames={{ content: styles.content, body: styles.body }}
    >
        <PlanDetails data={data} defaultTab={defaultTab} onClose={onClose} />
    </Modal>
);
